// src/components/common/vibe/EmojiPicker.js
import React, { useState } from 'react';
import { SmilePlus, Search } from 'lucide-react';

const EMOJI_CATEGORIES = {
    'Smileys & People': [
        '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊',
        '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪',
        '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏',
        '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕',
        '🤢', '🤮', '🤧', '🥵', '🥶', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐',
        '👍', '👎', '👊', '✊', '🤛', '🤜', '🤞', '✌️', '🤟', '🤘', '👌', '🤏',
        '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤙', '💪',
        '👏', '🙌', '👐', '🤲', '🤝', '🙏'
    ],
    'Animals & Nature': [
        '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮',
        '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧', '🐦', '🐤', '🦆', '🦅',
        '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜',
        '🌸', '🌺', '🌻', '🌹', '🌷', '🌼', '🌱', '🌲', '🌳', '🌴', '🌵', '🌾',
        '🍀', '🍁', '🍂', '🍃', '☘️', '🌿', '🍄', '🌰', '🌹', '🥀', '💐', '🌷'
    ],
    'Food & Drink': [
        '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🥭',
        '🍍', '🥥', '🥝', '🍅', '🥑', '🍆', '🥔', '🥕', '🌽', '🌶️', '🥒', '🥬',
        '🥦', '🧄', '🧅', '🍄', '🥜', '🌰', '🍞', '🥐', '🥖', '🥨', '🥯', '🥞',
        '🧇', '🧀', '🍖', '🍗', '🥩', '🥓', '🍔', '🍟', '🍕', '🌭', '🥪', '🌮',
        '☕', '🍵', '🧃', '🥤', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃', '🍸', '🍹'
    ],
    'Activities': [
        '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🏓', '🏸',
        '🏒', '🏑', '🥍', '🏏', '🥅', '⛳', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽',
        '🛹', '🛷', '⛸️', '🥌', '🎿', '⛷️', '🏂', '🏋️', '🤸', '🤺', '🤾', '🏇',
        '🧗', '🚴', '🚵', '🏎️', '🏍️', '🤹', '🎭', '🎨', '🎬', '🎤', '🎧', '🎼',
        '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🎻', '🎲', '♟️', '🎯', '🎳', '🎮'
    ],
    'Travel & Places': [
        '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛',
        '🚜', '🏍️', '🛵', '🚲', '🛴', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠',
        '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊',
        '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🚁', '🛰️', '🚀', '🛸', '🚢', '⛵',
        '🏠', '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦'
    ],
    'Objects': [
        '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️', '🗜️', '💽',
        '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽️', '🎞️', '📞', '☎️',
        '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️',
        '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸',
        '💰', '💴', '💵', '💶', '💷', '💳', '💎', '⚖️', '🧰', '🔧', '🔨', '⚒️'
    ],
    'Symbols': [
        '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕',
        '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉️', '☸️',
        '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈', '♉', '♊', '♋', '♌',
        '♍', '♎', '♏', '♐', '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️',
        '✅', '☑️', '✔️', '✖️', '❌', '❎', '➕', '➖', '➗', '➰', '➿', '〽️',
        '✳️', '✴️', '❇️', '©️', '®️', '™️', '🔚', '🔙', '🔛', '🔝', '🔜'
    ],
    'Flags': [
        '🏳️', '🏴', '🏁', '🚩', '🏳️‍🌈', '🇦🇺', '🇧🇷', '🇨🇦', '🇨🇳', '🇫🇷', '🇩🇪',
        '🇮🇳', '🇮🇩', '🇮🇹', '🇯🇵', '🇲🇽', '🇳🇱', '🇵🇱', '🇷🇺', '🇸🇦', '🇿🇦',
        '🇰🇷', '🇪🇸', '🇸🇪', '🇨🇭', '🇹🇷', '🇬🇧', '🇺🇸', '🇦🇪', '🇻🇳'
    ]
};

const EmojiPicker = ({ onEmojiSelect, theme, position = 'bottom' }) => {
    const [activeCategory, setActiveCategory] = useState('Smileys & People');
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const handleEmojiClick = (emoji) => {
        onEmojiSelect(emoji);
        setSearchTerm('');
    };

    const getFilteredEmojis = () => {
        if (!searchTerm) {
            return EMOJI_CATEGORIES[activeCategory];
        }

        // Search across all categories
        const allEmojis = Object.values(EMOJI_CATEGORIES).flat();
        return allEmojis.filter(emoji => emoji.includes(searchTerm));
    };

    const positionClasses = position === 'top'
        ? 'bottom-full mb-2'
        : 'top-full mt-2';

    return (
        <div className="relative">
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className={`p-2 rounded-lg transition-colors ${
                    theme === 'dark'
                        ? 'bg-gray-700 text-gray-400 hover:bg-gray-600'
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}
                title="Add emoji"
            >
                <SmilePlus className="w-5 h-5" />
            </button>

            {isOpen && (
                <>
                    {/* Backdrop to close picker */}
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />

                    {/* Emoji Picker Popup */}
                    <div className={`absolute ${positionClasses} left-0 z-50 w-80 rounded-lg shadow-xl border ${
                        theme === 'dark'
                            ? 'bg-gray-800 border-gray-700'
                            : 'bg-white border-gray-200'
                    }`}>
                        {/* Search */}
                        <div className="p-3 border-b border-gray-200 dark:border-gray-700">
                            <div className="relative">
                                <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 ${
                                    theme === 'dark' ? 'text-gray-500' : 'text-gray-400'
                                }`} />
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Search emoji..."
                                    className={`w-full pl-9 pr-3 py-2 rounded-lg border ${
                                        theme === 'dark'
                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                                            : 'bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-500'
                                    } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                                />
                            </div>
                        </div>

                        {/* Category Tabs */}
                        {!searchTerm && (
                            <div className={`flex overflow-x-auto border-b ${
                                theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                            }`}>
                                {Object.keys(EMOJI_CATEGORIES).map((category) => (
                                    <button
                                        key={category}
                                        type="button"
                                        onClick={() => setActiveCategory(category)}
                                        className={`px-3 py-2 text-xs font-medium whitespace-nowrap transition-colors ${
                                            activeCategory === category
                                                ? 'bg-blue-600 text-white'
                                                : theme === 'dark'
                                                    ? 'text-gray-400 hover:text-gray-200'
                                                    : 'text-gray-600 hover:text-gray-900'
                                        }`}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Emoji Grid */}
                        <div className="p-3 max-h-64 overflow-y-auto">
                            <div className="grid grid-cols-8 gap-1">
                                {getFilteredEmojis().map((emoji, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        onClick={() => handleEmojiClick(emoji)}
                                        className={`p-2 text-2xl rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors`}
                                        title={emoji}
                                    >
                                        {emoji}
                                    </button>
                                ))}
                            </div>
                            {getFilteredEmojis().length === 0 && (
                                <div className={`text-center py-8 ${
                                    theme === 'dark' ? 'text-gray-500' : 'text-gray-400'
                                }`}>
                                    <p className="text-sm">No emojis found</p>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default EmojiPicker;
